import { Trans } from '@lingui/macro'
import { Link } from 'react-router-dom'
import { useDarkModeManager } from 'state/user/hooks'
import styled from 'styled-components/macro'
import { ThemedText } from 'theme'
import { isMobile } from 'utils/userAgent'

import { SwitchLocaleLink } from '../../components/SwitchLocaleLink'

const PageWrapper = styled.div`
  max-width: 1200px;
  width: 100%;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    max-width: 800px;
  `};

  ${({ theme }) => theme.mediaWidth.upToSmall`
    max-width: 500px;
    margin-top: 5rem;
  `};
`
const ResponsiveGrid = styled.main<{ isMobile?: boolean }>`
  display: grid;
  gap 2em;
  justify-content: center;
  align-items: center;
  grid-template-columns: ${({ isMobile }) => (isMobile ? 'repeat(2, 10rem)' : 'repeat(3, 30rem)')};
  padding: 0 12px;
`

const Title = styled(ThemedText.LargeHeader)<{ isDark?: boolean }>`
  background: ${({ isDark }) =>
    isDark
      ? `-webkit-linear-gradient(
    90deg,
    rgba(255, 252, 2, 1) 0%,
    rgba(255, 172, 5, 1) 45%,
    rgba(255, 255, 255, 1) 50%,
    rgba(242, 49, 222, 1) 55%,
    rgba(153, 22, 255, 1) 100%
  )`
      : `-webkit-linear-gradient(
        90deg,
        rgba(255, 172, 5, 1) 48%,
        rgba(255, 255, 255, 1) 50%,
        rgba(242, 49, 222, 1) 52%,
        rgba(153, 22, 255, 1) 60%
      )`};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

export default function Home() {
  const [isDark] = useDarkModeManager()
  return (
    <>
      <PageWrapper>
        <div style={{ display: 'flex', justifyContent: 'center', margin: 'auto' }}>
          <img src={`${process.env.PUBLIC_URL}/images/Headboard.png`} alt="home" width={isMobile ? 360 : 600} />
        </div>
        <Title isDark={isDark} fontSize={isMobile ? '3rem' : '5rem'} textAlign="center" marginY="1rem">
          <Trans>Games</Trans>
        </Title>
        <ResponsiveGrid isMobile={isMobile}>
          <Link to={`${process.env.PUBLIC_URL}/dice`}>
            <img src={`${process.env.PUBLIC_URL}/images/games/miniaturas-16.png`} alt="" width={isMobile ? 163 : 513} />
          </Link>
          <Link to={`${process.env.PUBLIC_URL}/roulette`}>
            <img src={`${process.env.PUBLIC_URL}/images/games/miniaturas-15.png`} alt="" width={isMobile ? 163 : 553} />
          </Link>
          <Link to={`${process.env.PUBLIC_URL}/sport`}>
            <img src={`${process.env.PUBLIC_URL}/images/games/miniaturas-14.png`} alt="" width={isMobile ? 163 : 553} />
          </Link>

          {/* <ExternalLink href="https://games.bet2land.com/slot.php" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/images/games/miniaturas-21.png`} alt="" width={isMobile ? 163 : 513} />
          </ExternalLink> */}
          {/* <ExternalLink href="https://games.bet2land.com/fishing.php" target="_blank">
            <img src={`${process.env.PUBLIC_URL}/images/games/fishing.png`} alt="" width={isMobile ? 163 : 513} />
          </ExternalLink> */}

          {/* <img src={`${process.env.PUBLIC_URL}/images/games/miniaturas-32.png`} alt="" width={isMobile ? 163 : 513} /> */}
          <img src={`${process.env.PUBLIC_URL}/images/games/miniaturas-33.png`} alt="" width={isMobile ? 163 : 513} />
          <img src={`${process.env.PUBLIC_URL}/images/games/miniaturas-34.png`} alt="" width={isMobile ? 163 : 513} />
          <img src={`${process.env.PUBLIC_URL}/images/games/miniaturas-36.png`} alt="" width={isMobile ? 163 : 513} />
          <img src={`${process.env.PUBLIC_URL}/images/games/miniaturas-37.png`} alt="" width={isMobile ? 163 : 513} />
        </ResponsiveGrid>
      </PageWrapper>
      <SwitchLocaleLink />
    </>
  )
}
